export function postList() {
  let articles = document.querySelectorAll('article.post-list');

  if (!articles) return;

  [...articles].forEach(function (v, i, a) {
    let excerpt = v.querySelector('.excerpt');
    let parent = excerpt.parentNode;

    parent.style.transform = 'translateY(' + excerpt.offsetHeight + 'px)';

    parent.addEventListener('mouseenter', (e) => {
      parent.style.transform = 'translateY(0)';
    });
    parent.addEventListener('mouseleave', (e) => {
      parent.style.transform = 'translateY(' + excerpt.offsetHeight + 'px)';
    });

  });

  // Debounce
  function debounce(func, time) {
    var time = time || 100; // 100 by default if no param
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, time, event);
    };
  }

  // Function with stuff to execute
  function resizeContent() {
    [...articles].forEach(function (v, i, a) {
      let excerpt = v.querySelector('.excerpt');
      let parent = excerpt.parentNode;

      parent.style.transform = 'translateY(' + excerpt.offsetHeight + 'px)';

    });
  }
  window.addEventListener('resize', debounce(resizeContent, 150));

};
